module.exports = __webpack_public_path__ + "img/bakir-alt.c659ce83.png";